import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { DisposizioneCompagnia } from 'src/app/models/disposizione-compagnia';
import { DisposizioneCompagniaAllegato } from 'src/app/models/disposizione-compagnia-allegato';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { DisposizioneCompagniaService } from 'src/app/services/disposizione-compagnia.service';

@Component({
  selector: 'disposizione-allegati-dialog',
  templateUrl: './disposizione-allegati.component.html',
  styleUrls: ['./disposizione-allegati.component.scss']
})
export class DisposizioneAllegatiDialogComponent implements OnInit {

  disposizione: DisposizioneCompagnia;
  allegati: DisposizioneCompagniaAllegato[] = [];
  loading = false;
  uploading = false;

  @ViewChild('table') table: MatTable<DisposizioneCompagniaAllegato>;

  constructor(
    private disposizioneService: DisposizioneCompagniaService,
    private toast: ToastrService,
    private dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<DisposizioneAllegatiDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { disposizione: DisposizioneCompagnia },
  ) {
    this.disposizione = data?.disposizione;
  }

  ngOnInit(): void {
    this.loadAllegati();
  }

  async loadAllegati() {
    if (!this.disposizione?.id) {
      return;
    }
    this.loading = true;
    try {
      this.allegati = await this.disposizioneService.getAllegati(this.disposizione.id);
    } catch (error) {
      console.error(error);
      this.toast.error('Impossibile caricare gli allegati.', 'Errore');
    } finally {
      this.loading = false;
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file || !this.disposizione?.id) {
      return;
    }

    this.uploading = true;
    this.disposizioneService.uploadAllegato(this.disposizione.id, file).subscribe({
      next: allegato => {
        this.toast.success('Allegato caricato con successo.');
        this.allegati = [allegato, ...this.allegati];
        this.table?.renderRows();
      },
      error: err => {
        console.error(err);
        this.toast.error('Caricamento allegato fallito.', 'Errore');
      },
      complete: () => {
        this.uploading = false;
        if (input) {
          input.value = '';
        }
      }
    });
  }

  openDownload(allegato: DisposizioneCompagniaAllegato) {
    if (!this.disposizione?.id || !allegato?.id) {
      return;
    }

    this.disposizioneService.downloadAllegato(this.disposizione.id, allegato.id).subscribe({
      next: response => {
        const blob = response.body;
        if (!blob) {
          this.toast.error('Download allegato fallito.', 'Errore');
          return;
        }
        const filename = allegato.nome_originale || 'allegato';
        saveAs(blob, filename);
      },
      error: err => {
        console.error(err);
        this.toast.error('Download allegato fallito.', 'Errore');
      }
    });
  }

  deleteAllegato(allegato: DisposizioneCompagniaAllegato) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: `Sei sicuro di voler eliminare l'allegato ${allegato.humanIdentifier}?`
      }
    });

    dialogRef.afterClosed().subscribe(async confirmed => {
      if (!confirmed) {
        return;
      }
      try {
        await this.disposizioneService.deleteAllegato(this.disposizione.id, allegato.id);
        this.toast.success('Allegato eliminato.');
        this.allegati = this.allegati.filter(a => a.id !== allegato.id);
        this.table?.renderRows();
      } catch (error) {
        console.error(error);
        this.toast.error('Eliminazione allegato fallita.', 'Errore');
      }
    });
  }
}
